export const emailRegExp = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[\w-]{2,4}$/;

export const notAlphanumeric = /[^a-zA-Zа-яА-ЯёЁ0-9\s]/g;

export const anySlashRegExp = /^\/+|\\+|\/+$/g;

export const tabRegExp = /\s+/g;

export const specialSymbolRegExp = /[^\w-]/g;

export const urlWithProtocolRegExp = /^(?:[a-z]+:)?\/\//i;
